module.exports = __webpack_public_path__ + "static/media/img11.d311f0a6.jpeg";